import React from "react";
import ContextType from "./types/contextType";

// TODO abstract this common context
interface Props {
  context: any;
  //TODO
  children: any;
}

interface State {}

export default class App extends React.Component<Props, State> {
  static childContextTypes = ContextType;

  constructor(props: Props, context: any) {
    super(props, context);
    // const {whyDidYouUpdate} = require('why-did-you-update');
    // whyDidYouUpdate(React, { collapseComponentGroups: false});
  }

  getChildContext() {
    return this.props.context;
  }

  render() {
    // NOTE: If you need to add or modify header, footer etc. of the app,
    // please do that inside the Layout component.
    return React.Children.only(this.props.children);
  }
}
